/**
 * wrap google.maps.Map to an ol TileLayer
 */
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import * as proj from "ol/proj";

var GoogleMap = (function (TileLayer) {
  function GoogleMap(opt_options) {
    var self = this;
    var options = Object.assign({
      source: new XYZ({
        tileUrlFunction: (coordinate, pixelRatio, prj) => {
          //set in Map.ts
          let gm = self.gMap_;
          let olm = self.olMap_;
          if (!!gm && !!olm) {
            let gmZoom = gm.getZoom();
            let gmCenter = gm.getCenter();
            if (!!gmCenter && !!gmCenter.toJSON) {
              gmCenter = gmCenter.toJSON();
            }
            let view = olm.getView();
            let center = view.getCenter();
            let lngLat = proj.toLonLat(center);
            center = {
              lng: lngLat[0],
              lat: lngLat[1]
            };
            let zoom = coordinate[0];
            if (zoom!=gmZoom || !gmCenter || 
              center.lat!=gmCenter.lat || center.lng!=gmCenter.lng) {
              gm.setOptions({
                zoom: zoom,
                center: center
              });
            }
          }
          return null;
        }
      })
    }, opt_options || {});

    TileLayer.call(this, options);

    /**
     * @type {google.maps.MapTypeId<(number|string)>|string}
     * @private
     */
    var google = window.google; //google map api must be loaded in advanced
    this.mapTypeId_ = options.mapTypeId !== undefined ? options.mapTypeId :
      !!google ? google.maps.MapTypeId.ROADMAP : 'roadmap';
    
    this.gMap_ = null;
    this.olMap_ = null;
  }

  if ( TileLayer ) GoogleMap.__proto__ = TileLayer;
  GoogleMap.prototype = Object.create( TileLayer && TileLayer.prototype );
  GoogleMap.prototype.constructor = GoogleMap;

  /**
   * @return {google.maps.MapTypeId<(number|string)>|string} map type id
   * @api
   */
  GoogleMap.prototype.getMapTypeId = function getMapTypeId () {
    return this.mapTypeId_;
  };

  GoogleMap.prototype.setMapTypeId = function setMapTypeId (mapTypeId) {
    this.mapTypeId_ = mapTypeId;
    if (this.gMap_) {
      this.gMap_.setMapTypeId(mapTypeId);
    }
  };

  return GoogleMap;
}(TileLayer));
export default GoogleMap;
